<script>
  export let item;
</script>

<div class="stats-item col col-25 col-m-50 col-s-full">
  {#if item.icon}
    <img
      src={item.icon.src}
      alt={item.icon.alt}
      heigh={item.icon.height}
      width={item.icon.width}
      class="stats-item__icon"
    />
  {/if}
  {#if item.title}
    <h2 class="stats-item__title">
      {item.title}
    </h2>
  {/if}
  {#if item.desc}
    <p class="stats-item__desc text-small">{item.desc}</p>
  {/if}
</div>

<style lang="scss">
  .stats-item {
    text-align: center;

    &__icon {
      margin: 0 auto;
    }
    &__title {
      margin-top: 1rem;

      @include resp-range('l', 'xl') {
        font-size: 6rem;
      }

      @include resp-range('m', 'l') {
        font-size: 5rem;
      }
    }

    &__desc {
      margin-top: 1rem;
      color: var(--royal-light);
    }
  }
</style>
